document.addEventListener("DOMContentLoaded", () => {
    const counters = document.querySelectorAll(".counter");

    if (!counters.length) {
        return;
    }

    const hasDecimal = (num) => {
        return !Number.isInteger(num);
    };

    const startCounter = (element, target, speed, customStep = null) => {
        let count = 0;
        const step = customStep || target / 100;
        const useDecimal = customStep && hasDecimal(customStep);

        const interval = setInterval(() => {
            count += step;

            if (useDecimal) {
                element.innerText = count.toFixed(1); // 150.0
            } else {
                element.innerText = Math.round(count); // 150
            }

            if (count >= target) {
                element.innerText = useDecimal
                    ? target.toFixed(1)
                    : Math.round(target);

                clearInterval(interval);
            }
        }, speed);
    };

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const el = entry.target;
                const target = parseFloat(el.getAttribute("data-target"));
                const speed = parseInt(el.getAttribute("data-speed")) || 20;
                const customStep = parseFloat(el.getAttribute("data-step")) || null;

                startCounter(el, target, speed, customStep);
                observer.unobserve(el);
            }
        });
    }, { threshold: 0.5 });

    counters.forEach(counter => observer.observe(counter));
});